// Copyright (c) 2021, Elicenciamento. All rights reserved.

const breakpoints = {
  values: {
    xs: 0,
    sm: 360,
    md: 768,
    lg: 1280,
    xl: 1544,
  },
};

export default breakpoints;
